module.exports = __webpack_public_path__ + "static/background-ce174557722feaf3bac739c45fc798b7.jpg";